import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CardContent from '@material-ui/core/CardContent'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import CheckIcon from '@material-ui/icons/Check'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import GeneralInfoDialog from './GeneralInfoDialog'
import DescriptionDialog from './DescriptionDialog'
import AmenitiesDialog from './AmenitiesDialog'
import SpaceDialog from './SpaceDialog'

import { listOfAmenities } from '../../utils/_DATA'
import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
  },
  formControl: {
    margin: '0 0 10px',
    width: '300px',
    display: 'block'
  },
  dataRow: {
    width: '500px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  dataLabel: {
    width: '200px',
    lineHeight: '2rem'
  },
  dataValue: {
    width: '300px',
    lineHeight: '2rem',
    fontWeight: '500'
  },
  outOfDate: {
    fontWeight: '400',
    textDecoration: 'line-through'
  },
  updated: {
    color: 'rgb(244, 67, 54)'
  },
  deleted: {
    color: 'rgb(244, 67, 54)',
    textDecoration: 'line-through'
  },
  list: {
    width: '100%',
    maxWidth: '300px',
  },
  listItem: {
    paddingLeft: '0'
  },
  listChangedItem: {
    color: 'rgb(198, 40, 40)'
  }
});

class OfficeDataTab extends Component {
  state = {
    openGeneralInfoDialog: false,
    openDescriptionDialog: false,
    openAmenitiesDialog: false,
    openSpaceDialog: false
  }

  handleGeneralInfoDialogOpen = (event) => {
    this.setState({ openGeneralInfoDialog: true });
  }

  handleGeneralInfoDialogClose = () => {
    this.setState({ openGeneralInfoDialog: false });
  }

  handleDescriptionDialogOpen = (event) => {
    this.setState({ openDescriptionDialog: true });
  }

  handleDescriptionDialogClose = () => {
    this.setState({ openDescriptionDialog: false });
  }

  handleAmenitiesDialogOpen = (event) => {
    this.setState({ openAmenitiesDialog: true });
  }

  handleAmenitiesDialogClose = () => {
    this.setState({ openAmenitiesDialog: false });
  }

  handleSpaceDialogOpen = (event) => {
    this.setState({ openSpaceDialog: true });
  }

  handleSpaceDialogClose = () => {
    this.setState({ openSpaceDialog: false });
  }

  render() {
    const { openGeneralInfoDialog, openDescriptionDialog, openAmenitiesDialog, openSpaceDialog } = this.state
    const { classes, data } = this.props
    const lang = 'en'
    const update = data.update

    let currentSpace = []
    let updatedSpace = []

    if (data.space) {
      Object.values(data.space).map(space => {
        currentSpace[space.floor] = space.area
      })
    }

    if (typeof update === 'object' && update.hasOwnProperty('space')) {
      Object.values(update.space).map(space => {
        updatedSpace[space.floor] = space.area
      })
    }

    //console.log(data)
    //console.log(typeof update)

    return (
      <Fragment>
        <CardContent>
          <ExpansionPanel defaultExpanded>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>{t[lang].generalInformation}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div className={classes.dataRow}>
                <Typography className={classes.dataLabel}>{t[lang].name}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('name') && data.name !== update.name
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.name}</span>
                        <span className={classes.updated}> {update.name}</span>
                      </Fragment>)
                    : data.name}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].totalArea}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('totalArea') && data.totalArea !== update.totalArea
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.totalArea}</span>
                        <span className={classes.updated}> {update.totalArea}</span>
                      </Fragment>)
                    : data.totalArea}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].workStations}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('workStations') && data.workStations !== update.workStations
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.workStations}</span>
                        <span className={classes.updated}> {update.workStations}</span>
                      </Fragment>)
                    : data.workStations}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].availability}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('availability') && data.availability !== update.availability
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.availability}</span>
                        <span className={classes.updated}> {update.availability}</span>
                      </Fragment>)
                    : data.availability}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].minLeaseTerm}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('minLeaseTerm') && data.minLeaseTerm !== update.minLeaseTerm
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.minLeaseTerm}</span>
                        <span className={classes.updated}> {update.minLeaseTerm}</span>
                      </Fragment>)
                    : data.minLeaseTerm}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].numberOfParkings}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('numberOfParkings') && data.numberOfParkings !== update.numberOfParkings
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.numberOfParkings}</span>
                        <span className={classes.updated}> {update.numberOfParkings}</span>
                      </Fragment>)
                    : data.numberOfParkings}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].type}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('type') && data.type !== update.type
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.type}</span>
                        <span className={classes.updated}> {update.type}</span>
                      </Fragment>)
                    : data.type}
                </Typography>

                {/*<Typography className={classes.dataLabel}>{t[lang].status}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('status') && data.status !== update.status
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.status}</span>
                        <span className={classes.updated}> {update.status}</span>
                      </Fragment>)
                    : data.status}
                </Typography>*/}

                <Typography className={classes.dataLabel}>{t[lang].openingDate}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('openingDate') && data.openingDate !== update.openingDate
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.openingDate}</span>
                        <span className={classes.updated}> {update.openingDate}</span>
                      </Fragment>)
                    : data.openingDate}
                </Typography>

                <Typography className={classes.dataLabel}>{t[lang].website}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('website') && data.website !== update.website
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.website}</span>
                        <span className={classes.updated}> {update.website}</span>
                      </Fragment>)
                    : data.website}
                </Typography>
                <Typography className={classes.dataLabel}>{t[lang].showOnWebsite}</Typography>
                <Typography className={classes.dataValue}>
                  {typeof update === 'object' && update.hasOwnProperty('showOnWebsite') && data.showOnWebsite !== update.showOnWebsite
                    ? (<Fragment>
                        <span className={classes.outOfDate}>{data.showOnWebsite === '1' ? 'Yes' : 'No'}</span>
                        <span className={classes.updated}> {update.showOnWebsite === '1' ? 'Yes' : 'No'}</span>
                      </Fragment>)
                    : (data.showOnWebsite === '1' ? 'Yes' : 'No')}
                </Typography>
              </div>
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button size="small" color="primary" onClick={event => this.handleGeneralInfoDialogOpen(event)}>
                Edit
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>

          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>{t[lang].spaceHeader}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div>
                {((data.space && data.space.length > 0) || (typeof update === 'object' && update.hasOwnProperty('space')))  && (
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Floor</TableCell>
                        <TableCell align="right">Area</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.values(data.space).map((space, index) =>
                        updatedSpace[space.floor] || (typeof update === 'object' && !update.hasOwnProperty('space'))
                          ? (<TableRow key={index}>
                              <TableCell align="right">{space.floor}</TableCell>
                              <TableCell align="right">
                                {typeof update === 'object' && update.hasOwnProperty('space') && updatedSpace[space.floor] !== space.area
                                  ? (<Fragment>
                                      <span className={classes.outOfDate}>{space.area}</span>
                                      <span className={classes.updated}>{updatedSpace[space.floor]}</span>
                                    </Fragment>)
                                  : space.area}
                              </TableCell>
                            </TableRow>)
                          : (<TableRow key={index}>
                              <TableCell align="right" className={classes.deleted}>{space.floor}</TableCell>
                              <TableCell align="right" className={classes.deleted}>{space.area}</TableCell>
                            </TableRow>)
                      )}

                      {typeof update === 'object' && update.hasOwnProperty('space') && Object.values(update.space).map((space, index) =>
                        !currentSpace[space.floor] && (<TableRow key={index}>
                          <TableCell align="right" className={classes.updated}>{space.floor}</TableCell>
                          <TableCell align="right" className={classes.updated}>{space.area}</TableCell>
                        </TableRow>)
                      )}
                    </TableBody>
                  </Table>
                )}

                {data.space && data.space.length === 0 && !update.hasOwnProperty('space') && (
                  <Typography>No space data yet</Typography>
                )}
              </div>
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button size="small" color="primary" onClick={event => this.handleSpaceDialogOpen(event)}>
                Edit
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>

          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>{t[lang].amenities}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List className={classes.list}>
                {data.amenities && listOfAmenities[lang].filter((a) => (data.amenities.indexOf(a.id.toString()) !== -1)).map(a => (
                  <ListItem key={a.id} className={classes.listItem}>
                    <ListItemIcon>
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText primary={a.title} />
                  </ListItem>
                ))}

                {data.amenities && typeof update === 'object' && update.hasOwnProperty('amenities') && data.amenities !== update.amenities
                  && listOfAmenities[lang].filter((a) => (data.amenities.indexOf(a.id.toString()) === -1 && update.amenities.indexOf(a.id.toString()) !== -1)).map(a => (
                  <ListItem key={a.id} className={classes.listItem}>
                    <ListItemIcon className={classes.listChangedItem}>
                      <AddIcon />
                    </ListItemIcon>
                    <ListItemText primary={a.title} classes={{ primary: `${classes.listChangedItem}` }} />
                  </ListItem>
                ))}

                {data.amenities && typeof update === 'object' && update.hasOwnProperty('amenities') && data.amenities !== update.amenities
                  && listOfAmenities[lang].filter((a) => (data.amenities.indexOf(a.id.toString()) !== -1 && update.amenities.indexOf(a.id.toString()) === -1)).map(a => (
                  <ListItem key={a.id} className={classes.listItem}>
                    <ListItemIcon className={classes.listChangedItem}>
                      <RemoveIcon />
                    </ListItemIcon>
                    <ListItemText primary={a.title} classes={{ primary: `${classes.listChangedItem}` }} />
                  </ListItem>
                ))}
                {data.amenities && data.amenities.length === 0 && !update.hasOwnProperty('amenities') && (
                  <Typography gutterBottom>There are no amenities yet.</Typography>
                )}
              </List>
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button size="small" color="primary" onClick={event => this.handleAmenitiesDialogOpen(event)}>
                Edit
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>

          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>{t[lang].descriptionHeader}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div>
                <Typography variant="headline" gutterBottom>{t[lang].buildingDescription}</Typography>
                {typeof update === 'object' && update.hasOwnProperty('buildingDescriptionPL') && data.buildingDescriptionPL !== update.buildingDescriptionPL
                  ? (<Fragment>
                      <Typography gutterBottom className={classes.outOfDate}>{data.buildingDescriptionPL}</Typography>
                      <Typography gutterBottom className={classes.updated}> {update.buildingDescriptionPL}</Typography>
                    </Fragment>)
                  : <Typography gutterBottom>{data.buildingDescriptionPL}</Typography>}

                {typeof update === 'object' && update.hasOwnProperty('buildingDescriptionEN') && data.buildingDescriptionEN !== update.buildingDescriptionEN
                  ? (<Fragment>
                      <Typography gutterBottom className={classes.outOfDate} style={{ fontStyle: 'italic' }}>{data.buildingDescriptionEN}</Typography>
                      <Typography gutterBottom className={classes.updated} style={{ fontStyle: 'italic' }}> {update.buildingDescriptionEN}</Typography>
                    </Fragment>)
                  : <Typography gutterBottom style={{ fontStyle: 'italic' }}>{data.buildingDescriptionEN}</Typography>}

                <Typography variant="headline" gutterBottom style={{ marginTop: '20px' }}>{t[lang].locationDescription}</Typography>
                {typeof update === 'object' && update.hasOwnProperty('locationDescriptionPL') && data.locationDescriptionPL !== update.locationDescriptionPL
                  ? (<Fragment>
                      <Typography gutterBottom className={classes.outOfDate}>{data.locationDescriptionPL}</Typography>
                      <Typography gutterBottom className={classes.updated}> {update.locationDescriptionPL}</Typography>
                    </Fragment>)
                  : <Typography gutterBottom>{data.locationDescriptionPL}</Typography>}

                {typeof update === 'object' && update.hasOwnProperty('locationDescriptionEN') && data.locationDescriptionEN !== update.locationDescriptionEN
                  ? (<Fragment>
                      <Typography gutterBottom className={classes.outOfDate} style={{ fontStyle: 'italic' }}>{data.locationDescriptionEN}</Typography>
                      <Typography gutterBottom className={classes.updated} style={{ fontStyle: 'italic' }}> {update.locationDescriptionEN}</Typography>
                    </Fragment>)
                  : <Typography gutterBottom style={{ fontStyle: 'italic' }}>{data.locationDescriptionEN}</Typography>}
              </div>
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button size="small" color="primary" onClick={event => this.handleDescriptionDialogOpen(event)}>
                Edit
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
        </CardContent>

        {data.id && (
          <Fragment>
            <GeneralInfoDialog officeId={data.id} data={data.form} open={openGeneralInfoDialog} handleClose={this.handleGeneralInfoDialogClose} />
            <DescriptionDialog officeId={data.id} data={data.form} open={openDescriptionDialog} handleClose={this.handleDescriptionDialogClose} />
            <AmenitiesDialog officeId={data.id} data={data.form} open={openAmenitiesDialog} handleClose={this.handleAmenitiesDialogClose} />
            <SpaceDialog officeId={data.id} data={data.form} open={openSpaceDialog} handleClose={this.handleSpaceDialogClose} />
          </Fragment>
        )}
      </Fragment>
    )
  }
}

OfficeDataTab.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired
}

export default withStyles(styles)(OfficeDataTab)


// WEBPACK FOOTER //
// ./src/components/Offices/OfficeDataTab.js